import { BrowserRouter, Route, Routes } from "react-router-dom";
import AuthProvider from "./provider/AuthProvider";
import Layout from "./components/general/Layout";
import ContractsOverview from "./components/contractManagement/ContractsOverview";
import ContractWorkflow from "./components/contractManagement/ContractWorkflow";
import ContractProvider from "./provider/ContractProvider";
import AnalysisPage from "./components/analysis/AnalysisPage";
import RuleOverview from "./components/ruleManagement/RuleOverview";
import TopicOverview from "./components/topicManagement/TopicOverview";
import UserOverview from "./components/userManagement/UserOverview";
import RequireAdmin from "./provider/RequireAdmin";
import PageNotFound from "./components/general/PageNotFound";
import LandingPage from "./components/landingPage/LandingPage";
import Impressum from "./components/landingPage/Impressum";
import AGB from "./components/landingPage/AGB";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/impressum" element={<Impressum />} />
                <Route path="/nutzungsbedingungen" element={<AGB />} />

                <Route
                    path="/app"
                    element={
                        <AuthProvider>
                            <Layout />
                        </AuthProvider>
                    }
                >
                    <Route index element={<ContractsOverview />} />
                    <Route
                        path="contract/:contractId"
                        element={
                            <ContractProvider>
                                <ContractWorkflow />
                            </ContractProvider>
                        }
                    />
                    <Route path="analysis" element={<AnalysisPage />} />

                    <Route
                        path="rules"
                        element={
                            <RequireAdmin>
                                <RuleOverview />
                            </RequireAdmin>
                        }
                    />
                    <Route
                        path="topics"
                        element={
                            <RequireAdmin>
                                <TopicOverview />
                            </RequireAdmin>
                        }
                    />
                    <Route
                        path="users"
                        element={
                            <RequireAdmin>
                                <UserOverview />
                            </RequireAdmin>
                        }
                    />

                    <Route path="*" element={<PageNotFound />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
